import React from "react";
import {
  Box,
  Container,
  Typography,
  Paper,
  Grid,
//   Avatar,
  Divider,
  Chip,
  useTheme,
  useMediaQuery,
} from "@mui/material";

import { Helmet } from "react-helmet";

import GavelIcon from "@mui/icons-material/Gavel";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import CopyrightIcon from "@mui/icons-material/Copyright";
import LinkIcon from "@mui/icons-material/Link";
import SecurityIcon from "@mui/icons-material/Security";

// import  logo from "../images/Flavrapogi-Logo.png";  

const TermsAndConditions = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  const cardStyle = {
    p: { xs: 3, md: 4 },
    borderRadius: 5,
    height: "100%",
    background:
      "linear-gradient(145deg, rgba(255,255,255,0.96), rgba(248,250,255,0.92))",
    backdropFilter: "blur(12px)",
    border: "1px solid rgba(255,255,255,0.4)",
    transition: "all 0.3s ease",
    boxShadow: "0 10px 30px rgba(0,0,0,0.08)",
    "&:hover": {
      transform: "translateY(-6px)",
      boxShadow: "0 18px 40px rgba(0,0,0,0.15)",
    },
  };

  return (
    <>
      <Helmet>
        <title>Terms & Conditions | Flavrapogi</title>

        <meta
          name="description"
          content="Read the Terms and Conditions of Flavrapogi."
        />
      </Helmet>

      <Container
        maxWidth="100vw"
        sx={{
          minHeight: "100vh",
          py: 6,
          background: `
            linear-gradient(
              135deg,
              #0f172a 0%,
              #1e1b4b 25%,
              #312e81 55%,
              #4f46e5 80%,
              #818cf8 100%
            )
          `,
        }}
      >
        {/* Header */}
        <Box
          sx={{
            textAlign: "center",
            color: "white",
            mb: 6,
            mt: 3,
          }}
        >
          {/* <Avatar
            src={logo}
            sx={{
              width: isMobile ? 85 : 110,
              height: isMobile ? 85 : 110,
              mx: "auto",
              mb: 2,
              boxShadow: "0 15px 35px rgba(0,0,0,0.4)",
            }}
          /> */}

          <Chip
            label="Legal Information"
            sx={{
              mb: 2,
              background: "rgba(255,255,255,0.14)",
              color: "white",
              fontWeight: 600,
              backdropFilter: "blur(10px)",
            }}
          />

          <Typography
            variant={isMobile ? "h4" : "h3"}
            sx={{
              fontWeight: 800,
              mb: 1,
              letterSpacing: 1,
            }}
          >
            Terms & Conditions
          </Typography>

          <Typography
            variant="subtitle1"
            sx={{
              color: "rgba(255,255,255,0.85)",
            }}
          >
            Last updated on April 1, 2025
          </Typography>
        </Box>

        {/* Main Wrapper */}
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
          }}
        >
          <Box
            sx={{
              width: "100%",
              maxWidth: "1500px",
            }}
          >
            {/* Hero Section */}
            <Paper
              elevation={0}
              sx={{
                p: { xs: 4, md: 6 },
                borderRadius: 6,
                mb: 5,
                background: "rgba(255,255,255,0.12)",
                backdropFilter: "blur(16px)",
                border: "1px solid rgba(255,255,255,0.18)",
                position: "relative",
                overflow: "hidden",
              }}
            >
              {/* Decorative Glow */}
              <Box
                sx={{
                  position: "absolute",
                  width: 280,
                  height: 280,
                  borderRadius: "50%",
                  background: "rgba(129,140,248,0.18)",
                  top: -100,
                  right: -70,
                  filter: "blur(45px)",
                }}
              />

              <Box
                sx={{
                  position: "relative",
                  zIndex: 2,
                }}
              >
                <Box
                  sx={{
                    width: 100,
                    height: 100,
                    borderRadius: "50%",
                    background:
                      "linear-gradient(135deg, #4f46e5, #818cf8)",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    mx: "auto",
                    mb: 4,
                    boxShadow: "0 14px 35px rgba(79,70,229,0.35)",
                  }}
                >
                  <GavelIcon
                    sx={{
                      fontSize: 50,
                      color: "white",
                    }}
                  />
                </Box>

                <Typography
                  variant={isMobile ? "h4" : "h3"}
                  sx={{
                    textAlign: "center",
                    fontWeight: 700,
                    color: "white",
                    mb: 3,
                  }}
                >
                  Please Read Carefully
                </Typography>

                <Typography
                  variant="h6"
                  sx={{
                    color: "rgba(255,255,255,0.9)",
                    lineHeight: 1.9,
                    textAlign: "center",
                    maxWidth: "1000px",
                    mx: "auto",
                    fontWeight: 400,
                  }}
                >
                  These Terms and Conditions govern your use of our website,
                  services, and any purchases made through FLAVR APOGI
                  HEALTHCARE AND INDUSTRIAL CATERING SERVICES PRIVATE LIMITED.
                </Typography>
              </Box>
            </Paper>

            {/* Definitions */}
            <Grid container spacing={4}>
              <Grid item xs={12}>
                <Paper sx={cardStyle}>
                  <Box
                    display="flex"
                    alignItems="center"
                    gap={2}
                    mb={3}
                  >
                    <InfoOutlinedIcon
                      sx={{
                        color: "#4338ca",
                        fontSize: 36,
                      }}
                    />

                    <Typography variant="h5" fontWeight={700}>
                      Definitions
                    </Typography>
                  </Box>

                  <Divider sx={{ mb: 3 }} />

                  <Typography
                    variant="body1"
                    sx={{
                      lineHeight: 2,
                      mb: 3,
                    }}
                  >
                    The term <strong>"we", "us", "our"</strong> used anywhere on
                    this page shall mean FLAVR APOGI HEALTHCARE AND INDUSTRIAL
                    CATERING SERVICES PRIVATE LIMITED, whose
                    registered/operational office is:
                  </Typography>

                  <Paper
                    elevation={0}
                    sx={{
                      p: 3,
                      borderRadius: 3,
                      background: "rgba(79,70,229,0.08)",
                      mb: 3,
                    }}
                  >
                    <Typography
                      variant="body1"
                      sx={{
                        lineHeight: 1.9,
                        fontWeight: 500,
                      }}
                    >
                      PLOT NO-77/958, MANASI, MADHUBAN, NIJIGARH,
                      KURKI, PIPLI Khorda ODISHA 752050
                    </Typography>
                  </Paper>

                  <Typography
                    variant="body1"
                    sx={{
                      lineHeight: 2,
                    }}
                  >
                    <strong>"you", "your", "user", "visitor"</strong> shall mean
                    any natural or legal person who is visiting our website
                    and/or agreed to purchase from us.
                  </Typography>
                </Paper>
              </Grid>

              {/* General Terms */}
              <Grid item xs={12} md={6}>
                <Paper sx={cardStyle}>
                  <Box
                    display="flex"
                    alignItems="center"
                    gap={2}
                    mb={3}
                  >
                    <SecurityIcon
                      sx={{
                        color: "#0f766e",
                        fontSize: 36,
                      }}
                    />

                    <Typography variant="h5" fontWeight={700}>
                      General Terms
                    </Typography>
                  </Box>

                  <Divider sx={{ mb: 3 }} />

                  <Box
                    component="ul"
                    sx={{
                      pl: 3,
                      lineHeight: 2.2,
                    }}
                  >
                    <li>
                      <Typography>
                        Website content may change without notice.
                      </Typography>
                    </li>

                    <li>
                      <Typography>
                        We do not guarantee complete accuracy or suitability of
                        website information.
                      </Typography>
                    </li>

                    <li>
                      <Typography>
                        Your use of information or materials is entirely at your
                        own risk.
                      </Typography>
                    </li>

                    <li>
                      <Typography>
                        You are responsible for ensuring products/services meet
                        your requirements.
                      </Typography>
                    </li>
                  </Box>
                </Paper>
              </Grid>

              {/* Intellectual Property */}
              <Grid item xs={12} md={6}>
                <Paper sx={cardStyle}>
                  <Box
                    display="flex"
                    alignItems="center"
                    gap={2}
                    mb={3}
                  >
                    <CopyrightIcon
                      sx={{
                        color: "#dc2626",
                        fontSize: 36,
                      }}
                    />

                    <Typography variant="h5" fontWeight={700}>
                      Intellectual Property
                    </Typography>
                  </Box>

                  <Divider sx={{ mb: 3 }} />

                  <Typography
                    variant="body1"
                    sx={{
                      lineHeight: 2,
                    }}
                  >
                    Our website contains material owned by or licensed to us.
                    This includes design, layout, graphics, appearance, and
                    content.
                    <br />
                    <br />
                    Reproduction is prohibited except in accordance with the
                    copyright notice forming part of these terms.
                    <br />
                    <br />
                    Unauthorized use of information provided by us may give rise
                    to claims for damages and/or criminal offense.
                  </Typography>
                </Paper>
              </Grid>

              {/* Links to Other Websites */}
              <Grid item xs={12}>
                <Paper sx={cardStyle}>
                  <Box
                    display="flex"
                    alignItems="center"
                    gap={2}
                    mb={3}
                  >
                    <LinkIcon
                      sx={{
                        color: "#7c3aed",
                        fontSize: 36,
                      }}
                    />

                    <Typography variant="h5" fontWeight={700}>
                      Links to Other Websites
                    </Typography>
                  </Box>

                  <Divider sx={{ mb: 3 }} />

                  <Typography
                    variant="body1"
                    sx={{
                      lineHeight: 2,
                    }}
                  >
                    Our website may include links to other websites for your
                    convenience and additional information.
                    <br />
                    <br />
                    You may not create a link to our website from another
                    website or document without FLAVR APOGI HEALTHCARE AND
                    INDUSTRIAL CATERING SERVICES PRIVATE LIMITED's prior written
                    consent.
                    <br />
                    <br />
                    Any dispute arising out of use of our website and/or
                    purchase with us shall be subject to the laws of India.
                    <br />
                    <br />
                    We shall not be liable for any loss or damage arising
                    directly or indirectly out of the decline of authorization
                    for any transaction on account of the cardholder exceeding
                    preset limits agreed with our acquiring bank.
                  </Typography>
                </Paper>
              </Grid>

              {/* Footer Note */}
              <Grid item xs={12}>
                <Paper
                  sx={{
                    p: { xs: 3, md: 5 },
                    borderRadius: 5,
                    textAlign: "center",
                    background:
                      "linear-gradient(135deg, #312e81, #4338ca, #6366f1)",
                    color: "white",
                    boxShadow: "0 15px 40px rgba(49,46,129,0.3)",
                  }}
                >
                  <Typography
                    variant={isMobile ? "h5" : "h4"}
                    sx={{
                      fontWeight: 700,
                      mb: 2,
                    }}
                  >
                    By Using Our Website
                  </Typography>

                  <Typography
                    variant="body1"
                    sx={{
                      lineHeight: 2,
                      maxWidth: "900px",
                      mx: "auto",
                      color: "rgba(255,255,255,0.9)",
                    }}
                  >
                    You acknowledge that you have read, understood, and agreed
                    to these Terms and Conditions and comply with all applicable
                    laws and regulations.
                  </Typography>
                </Paper>
              </Grid>
            </Grid>
          </Box>
        </Box>
      </Container>
    </>
  );
};

export default TermsAndConditions;